import { Grid, Stack, Typography, Box, Divider } from "@mui/material";
import { SocialLinks } from "../../../components/Footer/SocialLinks";
import Header from "../../../components/Header";

const Info = () => {
  return (
    <Box maxWidth={1000} mx="auto" mt={12} px={2}>
      <Typography
        data-aos="fade-up"
        variant="h3"
        typography={{ xs: "h4", sm: "h3" }}
        sx={{ fontWeight: "600 !important" }}
      >
        Inspired by Goa’s rich culture of hosting and celebration, Inspire
        Luxury Goa curates personalized experiences, ensuring every guest enjoys
        a warm, memorable stay.
      </Typography>
      {/* <Typography color="text.secondary" mt={4} variant="h6" fontWeight={500}>
        Inspire Luxury Goa is a family-run stay dedicated to exceptional
        hospitality. Over the past four years, we have welcomed 1,000+ guests,
        earning an aggregate 4.9 rating across OTA platforms and a 30-35% repeat
        guest rate, reflecting our commitment to guest satisfaction. <br />{" "}
      </Typography> */}
      {/* <Box px={{ xs: 1, sm: 0 }}>
        <Header
          label="Why us"
          title="True Goan Hospitality"
          desc="Experience the warmth and charm of authentic Goan hospitality at Inspire Luxury."
        />
        <Box
          data-aos="fade-up"
          data-aos-delay={300}
          borderRadius={12}
          p={{ xs: 2, sm: 4 }}
          mt={{ xs: 4, sm: 8 }}
          border="1px solid #ffffff40"
        >
          <Grid
            container
            direction={{ xs: "column-reverse", md: "row-reverse" }}
            alignItems="center"
            spacing={6}
          >
            <Grid item xs={12} sm={7}>
              <Box p={{ xs: 1, sm: 0 }}>
                <Stack alignItems="start">
                  <Typography
                    variant="body1"
                    fontWeight={500}
                    color="text.secondary"
                    mb={4}
                  >
                    Inspire Luxury Goa is a family-run stay dedicated to
                    exceptional hospitality. Over the past four years, we have
                    welcomed 1,000+ guests, earning an aggregate 4.9 rating
                    across OTA platforms and a 30-35% repeat guest rate,
                    reflecting our commitment to guest satisfaction. <br />{" "}
                    <br /> Inspired by Goa’s rich culture of hosting and
                    celebration, Villa Ananda Goa curates personalized
                    experiences, ensuring every guest enjoys a warm, memorable
                    stay.
                  </Typography>

                  <SocialLinks />
                </Stack>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={5}
              sx={{ width: { xs: "100%", md: "auto" } }}
            >
              <Box
                component="img"
                src="/images/about-us/image-placeholder.png"
                alt="img"
                sx={{
                  borderRadius: 8,
                  height: "auto",
                  objectFit: "cover",
                  display: "block",
                  width: "100%",
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box> */}
    </Box>
  );
};

export default Info;
